import React from "react";
import classes from "./formInput.module.css";

export const FormInput = ({
  id,
  label,
  type = "text",
  register,
  validation = {},
  disabled = false,
}) => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.inputBox}>
        <input
          id={id}
          type={type}
          disabled={disabled}
          className={`${classes.input} ${disabled ? classes.disabled : ""}`}
          {...(register ? register(id, validation) : {})}
          placeholder=" "
        />
        <label htmlFor={id} className={classes.floatingLabel}>
          {label}
        </label>
      </div>
    </div>
  );
};
